export function fileuploadmodalviewRender() {
    return `<div class="modal">
    <div class="modal-content" role="alertdialog" aria-modal="true" aria-labelledby="upload-disclaimer">
        <div class="modal-body file-upload-view">
            <div class="file-disclaimer" id="upload-disclaimer">${this.disclaimerText}</div>
              <!--  Add Rich media -->
            <div id="file-upload-container"></div>
            <div class="error-msg"></div>
        </div>
        <div class="modal-footer">
            <button class="modal-button cancel-button" style="${this.__$objToStyleMap(this.btnStyles)}" ld--elist="click" ld-on-click="onCancelClick">${this.cancelBtnText}</button>
            <button class="modal-button ok-button file-ok-button" style="${this.__$objToStyleMap(this.btnStyles)}" ld--elist="click" ld-on-click="onOkClick">${this.uploadBtnText}</button>
        </div>
    </div>
</div>`  }